import './Palette.svelte.css';
/* src/Palette.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	toggle_class
} from "./_snowpack/pkg/svelte/internal.js";

import { createEventDispatcher } from './_snowpack/pkg/svelte.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	child_ctx[8] = i;
	return child_ctx;
}

// (55:4) {#each tools as tool, index}
function create_each_block(ctx) {
	let div;
	let div_style_value;
	let mounted;
	let dispose;

	function click_handler() {
		return /*click_handler*/ ctx[3](/*index*/ ctx[8]);
	}

	return {
		c() {
			div = element("div");
			attr(div, "class", "color-tool svelte-qnxcx0");
			attr(div, "style", div_style_value = `background-color: ${/*tool*/ ctx[6].color}`);
			toggle_class(div, "color-selected", /*color*/ ctx[0] === /*index*/ ctx[8]);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (!mounted) {
				dispose = listen(div, "click", click_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*color*/ 1) {
				toggle_class(div, "color-selected", /*color*/ ctx[0] === /*index*/ ctx[8]);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div;
	let each_value = /*tools*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div, "class", "color-tools svelte-qnxcx0");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*tools, color, onClick*/ 7) {
				each_value = /*tools*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const dispatch = createEventDispatcher();
	let color = 15;
	let tools = [];

	// Apple II Palette
	let palette = [
		'#ffffff',
		'#ffff00',
		'#ff6500',
		'#dc0000',
		'#ff0097',
		'#360097',
		'#0000ca',
		'#0097ff',
		'#00a800',
		'#006500',
		'#653600',
		'#976536',
		'#b9b9b9',
		'#868686',
		'#454545',
		'#000000'
	];

	for (let i = 0; i < palette.length; i++) {
		tools.push({ type: 'color', color: palette[i] });
	}

	function onClick(index) {
		$$invalidate(0, color = index);
		dispatch('colorSelect', { index });
	}

	const click_handler = index => onClick(index);
	return [color, tools, onClick, click_handler];
}

class Palette extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Palette;